<template><label class="label"><slot /></label></template>
